import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { switchMap } from 'rxjs';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './core/interceptors/error';
import { apiInterceptor } from './core/interceptors/api';
import { LOCALE_ID } from '@angular/core';
import { provideI18n } from './shared/i18n/provide-i18n';
import { ConfigService } from './core/config/config.service';
import { AuthBootstrap } from './core/auth/auth-bootstrap';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiInterceptor, errorInterceptor])),
    provideAppInitializer(() => {
      const config = inject(ConfigService);
      const authBootstrap = inject(AuthBootstrap);
      return config.load().pipe(switchMap(() => authBootstrap.restore()));
    }),
    provideI18n(),
  ],
};
